import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./Header";
import AboutMe from "./AboutMe";
import LatestPost from "./LatestPosts";
import StayTouch from "./StayTouch";
import Footer from "./Footer";

const Home = () => {
  return (
    <div className="MainContainer">
      <AboutMe />
      {/* <div className="Container">
        I love to write articles and blogs you can find some of them from below
        section or from the blogs tab.I love to learn software developement key
        concepts.I have working experience in agile and scrum methodologies in
        software developement.Thanks for landing on my blogging page.
      </div> */}

      <LatestPost title="Latest Posts" />
      <LatestPost title="Projects" />
      <StayTouch />
      <Footer />
    </div>
  );
};

export default Home;
